"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { ProductCard } from "@/components/ProductCard/ProductCard.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
type CompanyProductProps = {
  readonly className?: string;
  readonly size?: "small" | "medium" | "large" | "default";
  readonly variant?: "primary" | "default" | "subtle";
  readonly position?: string;
};
export function CompanyProduct(t0) {
  const $ = _c(16);
  const {
    className,
    size,
    position
  } = t0;
  const {
    shopLinks: t1
  } = usePaywall();
  const {
    corporateUrl
  } = t1;
  let t2;
  if ($[0] !== className) {
    t2 = clsx(className, "relative flex hover:z-10 lg:py-2");
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      da: "Bliv kontaktet",
      de: "Kontaktieren Sie uns",
      en: "Get in touch",
      no: "Bli kontaktet",
      sv: "Bli kontaktad"
    };
    t4 = {
      da: "Flere brugere",
      de: "Mehrere Benutzer",
      en: "Multiple users",
      no: "Flere brukere",
      sv: "Flera anv\xE4ndare"
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      da: <>Virksomheds­abonnement</>,
      de: <>Unter­nehmens­abonnement</>,
      en: <>Company subscription</>,
      no: <>Bedrifts­abonnement</>,
      sv: <>Företags­prenumeration</>
    };
    t6 = {
      contentId: "corporate",
      contentSource: "paywall",
      contentType: "cta"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== corporateUrl || $[7] !== position) {
    t7 = {
      buttonTranslations: t3,
      periodHeadingTranslations: t4,
      position,
      testId: "corporate-link-button",
      titleTranslations: t5,
      trackingModel: t6,
      url: corporateUrl,
      variant: "subtle"
    };
    $[6] = corporateUrl;
    $[7] = position;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-col items-center justify-center gap-1 text-sm"><p><Translation da="Fuld adgang til flere brugere" de={"Vollzugriff f\xFCr mehrere Benutzer"} en="Full access for multiple users" no="Full tilgang for flere brukere" sv={"Full tillg\xE5ng f\xF6r flera anv\xE4ndare"} /></p><p><Translation da="Attraktiv pris per bruger" de="Attraktiver Preis pro Benutzer" en="Attractive price per user" no="Attraktiv pris per bruker" sv={"Attraktivt pris per anv\xE4ndare"} /></p></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== size || $[11] !== t7) {
    t9 = <ProductCard className="max-w-full" model={t7} size={size}>{t8}</ProductCard>;
    $[10] = size;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t9) {
    t10 = <div className={t2}>{t9}</div>;
    $[13] = t2;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}